import { UserAvatar } from '@/components/ui/name-avatar';

/**
 * Assignee cell for reminder listings: avatar + full name, rather than the
 * hover-only names of the shared renderMultiAvatars. Reminders are about who
 * owes what, so the name needs to be readable without hovering.
 */
const renderAssignees = (data) => {
  if (!data || (Array.isArray(data) && data.length === 0)) return <span>-</span>;

  const users = Array.isArray(data) ? data : [data];

  return (
    <div className="flex flex-col gap-1">
      {users.map((user) => {
        const fullName = user.first_name
          ? `${user.first_name} ${user.last_name || ''}`.trim()
          : 'Not Available';

        return (
          <div key={user.id} className="flex items-center gap-1.5">
            {user.profile_image ? (
              <img
                src={user.profile_image}
                className="size-6 rounded-full border border-success shrink-0"
                alt={fullName}
              />
            ) : (
              <UserAvatar name={fullName} className="!size-6 !text-[10px] !border !border-primary shrink-0" />
            )}
            <span className="text-xs text-gray-800 whitespace-nowrap">{fullName}</span>
          </div>
        );
      })}
    </div>
  );
};

export { renderAssignees };
